<template>
  <div>
    <div class="app-list pep-media">
      <div
        class="app-list__li"
        v-for="(item) in media"
        :key="`${item.date}-${item.title}`"
      >
        <span class="app-key-value__key">{{ item.date | formatDateDMY }}</span>
        <span class="app-key-value__value">
          <a
            target="_blank"
            :title="item.snippet"
            :href="item.url">{{ item.title }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/*
input model
[{ date snippet title url }]
*/

export default {
  name: 'verification-details-pep-info-media',
  components: {},
  props: {
    media: {
      type: Array,
      required: true,
    },
  },
  created () {
    this.media = this.media.sort(function (a, b) {
      return new Date(a.date) - new Date(b.date)
    })
  },
}
</script>

<style scoped>
  .pep-media .app-key-value__key {
    margin-left: 2em;
  }

  .app-list.pep-media a {
    padding: 2em;
  }
</style>
